<section class="login-right-panel" aria-label="Benefícios do ERP">
  <div class="panel-content">
    <header class="panel-header">
      <h1>Gestão <span>simplificada</span></h1>
      <p>Emissão de NF-e e NFC-e<br>de forma prática!</p>
      <div class="title-line" aria-hidden="true"></div>
    </header>

    <div class="benefits">
      <article class="benefit-item">
        <svg class="benefit-icon" viewBox="0 0 64 64" aria-hidden="true">
          <path d="M17 7h21l11 11v39H17z" />
          <path d="M38 7v12h11M25 30h16M25 39h16M25 48h12" />
        </svg>
        <div>
          <h2>Emita NF-e e NFC-e</h2>
          <p>De forma rápida e segura.</p>
        </div>
      </article>

      <article class="benefit-item">
        <svg class="benefit-icon" viewBox="0 0 64 64" aria-hidden="true">
          <path d="M10 55h45M15 50V38h8v12M28 50V28h8v22M41 50V17h8v33" />
        </svg>
        <div>
          <h2>Controle e organize</h2>
          <p>Financeiro, estoque e vendas em um só lugar.</p>
        </div>
      </article>

      <article class="benefit-item">
        <svg class="benefit-icon" viewBox="0 0 64 64" aria-hidden="true">
          <path d="M32 6c7 6 14 8 22 9v16c0 14-8 23-22 29C18 54 10 45 10 31V15c8-1 15-3 22-9z" />
          <path d="m21 32 7 7 15-16" />
        </svg>
        <div>
          <h2>Segurança e conformidade</h2>
          <p>Sistema atualizado com a legislação fiscal.</p>
        </div>
      </article>
    </div>

    <aside class="support-box">
      <svg class="support-icon" viewBox="0 0 64 64" aria-hidden="true">
        <path d="M12 35v-5a20 20 0 0 1 40 0v5" />
        <rect x="8" y="32" width="10" height="18" rx="5" />
        <rect x="46" y="32" width="10" height="18" rx="5" />
        <path d="M51 50c-2 7-7 9-14 9h-5" />
        <rect x="25" y="55" width="9" height="5" rx="2.5" />
      </svg>
      <div>
        <h2>Dúvidas?</h2>
        <p>Nosso time está pronto para ajudar.</p>
      </div>
    </aside>
  </div>
</section>